import { useState, useEffect } from 'react';

import './CookieNotification.css';
import { Link } from 'react-router-dom';

function CookieNotification() {
  const [showCookieNotice, setShowCookieNotice] = useState(true);

  useEffect(() => {
    const cookieNoticeShown = document.cookie
      .split(';')
      .some((cookie) => cookie.trim().startsWith('cookieNoticeShown=true'));

    if (!cookieNoticeShown) {
      setShowCookieNotice(true);
    } else {
      setShowCookieNotice(false);
    }
  }, []);

  const handleCloseNotice = () => {
    document.cookie =
      'cookieNoticeShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT';
    setShowCookieNotice(false);
  };

  return (
    <div
      className="cookie__notification"
      style={{ display: showCookieNotice ? 'block' : 'none' }}
    >
      <p>
        Посещая страницы Сайта и заполняя формы ввода данных, Вы подтверждаете
        своё согласие с нашей{' '}
        <Link className="footer__privacypolicy_link" to="/privacy_policy">
          Политикой конфиденциальности
        </Link>
        , включая использование файлов Cookie и сервисов аналитики (в том числе
        Яндекс.Метрики), необходимых для корректного функционирования и
        улучшения работы Сайта.
      </p>
      <button className="cookie__button" onClick={handleCloseNotice}>
        Хорошо
      </button>
    </div>
  );
}

export default CookieNotification;
